module.exports = __webpack_public_path__ + "img/service3.1264a700.svg";